<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>

    <StationInfo ref="info" :bus-item="rebuildItem"></StationInfo>


    <el-card v-if="this.clue === true && (this.detach || this.install) && (stationId === 'memory' || stationId ==='disk' || stationId ==='cpu' || stationId ==='gpu'|| stationId ==='network')"
             shadow="never" class="remind-card">
      <el-row v-if="this.detach">
        <el-col :span="20" class="item-text">需拆卸：{{ this.detach }}</el-col>
      </el-row>
      <el-row v-if="this.install">
        <el-col :span="20" class="item-text">需安装：{{ this.install }}</el-col>
      </el-row>
    </el-card>

    <div style="margin-top: 10px">
      <FrameForm ref="frameForm" :component-param="componentParam" :parent-data="{id:rebuildItem.id,
      station_id:stationId,sn:sn,installCnt:installCnt,installList:installList,detachCnt:detachCnt,originBomLine:originBomLine,targetBomLine:targetBomLine}">

      </FrameForm>
    </div>
  </div>
</template>

<script>
import StationInfo from "@/views/applications/rebuild/StationInfo.vue";

export default {
  name: "StationParent",
  components: {StationInfo},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      sn: '',
      install: '',
      installList: {},
      detach: '',
      installCnt: '',
      detachCnt: '',
      originBomLine: {},
      targetBomLine: {},
      canWork: false,
      loading: false,
      clue: false,
      rebuildItem: {},
    }
  },
  computed: {
    stationId() {
      if (this.componentParam && this.componentParam.length > 16) {
        return this.componentParam.substring(16);
      }
      return '';
    }
  },
  provide() {
    return {
      $fn: {
        reset: () => {
          this.sn = ''
          this.reset();
        }
      }
    }
  },
  methods: {
    async search() {
      this.reset()
      this.$refs.frameForm.formInfo = {} //清空作业表单内容

      if (!this.sn) {
        return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      this.$http('rebuildItemService.queryStationInfo', {
        station_id: this.stationId,
        sn: this.sn
      }, false).then(data => {
        this.loading = false
        this.rebuildItem = data.rebuildItem || {}
        this.canWork = true
        this.$refs.frameForm.initForm()
        this.clue = true
        return this.$refs.searchMessage.showSuccess('状态正常，请作业');
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })
      this.getBomDiff()
    },

    //根据物品信息获取需要拆卸和安装的物料
    async getBomDiff() {
      var params = {
        sn: this.sn,
        stationId: this.stationId
      }
      let bomDiff = await this.$http('rebuildItemService.getBomDiff', params)
      this.install = bomDiff.install
      this.installList = bomDiff.installList
      this.detach = bomDiff.detach
      this.installCnt = bomDiff.installCnt
      this.detachCnt = bomDiff.detachCnt
      this.originBomLine = bomDiff.originBomLine
      this.targetBomLine = bomDiff.targetBomLine
    },

    reset() {
      this.rebuildItem = {}
      this.clue = false
      this.canWork = false
      this.$refs.searchMessage.clear()

    }
  }
}
</script>

<style scoped>
.el-row {
  line-height: 32px;
}

.info-card {
  margin-top: 10px;
}

.remind-card {
  margin-top: 10px;
  width: 1000px;
}

.info-card .el-row {
  display: flex;
}

.input {
  height: 32px;
  width: 350px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: left;
}

.login-user {
  position: absolute;
  right: 10px;
}
</style>